import React from "react";

// Tailwind's build output orders utilities by its own internal scale, not by
// source order, so appending a caller's override className (e.g. "my-0")
// after the default "my-5" does NOT reliably win the cascade - "my-5" can
// still take effect regardless of which one appears later in the class
// string. Detect a caller-supplied UNCONDITIONAL margin utility per edge
// (top/bottom) and drop only the matching half of our default instead of
// letting the two silently fight it out - dropping the whole "my-5" on any
// margin utility (including an x-axis-only one like "mx-4") strips the axis
// the caller never touched. "Unconditional" matters too: a variant-scoped
// override (e.g. "md:my-2") only applies above that breakpoint, so it must
// never suppress the base default outright - that would leave zero vertical
// margin below the breakpoint, a worse bug than the one this fixes.
const stripBang = (token: string) => token.replace(/^!/, "").replace(/^-/, "");
const TOP_MARGIN = /^m[ty]?-/;
const BOTTOM_MARGIN = /^m[by]?-/;

export default function Divider({ className = "" }: { className?: string }) {
  const rawTokens = className.split(/\s+/).filter(Boolean);
  // Only a variant-free token (no "md:", "dark:", "hover:", etc. prefix)
  // can suppress the base default - a scoped override layers on top of it.
  const unconditionalTokens = rawTokens
    .filter((t) => !t.includes(":"))
    .map(stripBang);
  const base = ["h-px", "bg-zinc-100"];
  if (!unconditionalTokens.some((t) => TOP_MARGIN.test(t))) base.push("mt-5");
  if (!unconditionalTokens.some((t) => BOTTOM_MARGIN.test(t)))
    base.push("mb-5");
  return <div className={`${base.join(" ")} ${className}`.trim()} />;
}
